export const subCategoryNavTemplate = (itemID) =>`
<nav id="${itemID}" class="subcat-nav head-drop-menu"></nav>
`